import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, SunIcon, MoonIcon } from '../icons/Icons';
import { PATH_LABELS } from '../Sidebar/navConfig';
import type { Theme } from '../../hooks/useTheme';
import { UserMenu } from './UserMenu';
import './Header.css';

interface HeaderProps {
  theme: Theme;
  onToggleSidebar: () => void;
  onToggleTheme: () => void;
}

function useBreadcrumbs() {
  const { pathname } = useLocation();
  const segments = pathname.split('/').filter(Boolean);
  return segments.map((seg, i) => ({
    label: PATH_LABELS[seg] ?? seg,
    to: '/' + segments.slice(0, i + 1).join('/'),
    last: i === segments.length - 1,
  }));
}

export function Header({ theme, onToggleSidebar, onToggleTheme }: HeaderProps) {
  const crumbs = useBreadcrumbs();

  return (
    <header className="header">
      <button type="button" className="header__icon-btn" onClick={onToggleSidebar} aria-label="Toggle menu">
        <MenuIcon />
      </button>

      <nav className="header__breadcrumb" aria-label="Breadcrumb">
        <Link className="header__crumb" to="/">Home</Link>
        {crumbs.map((c) => (
          <span className="header__crumb-wrap" key={c.to}>
            <span className="header__crumb-sep">/</span>
            {c.last ? (
              <span className="header__crumb header__crumb--current">{c.label}</span>
            ) : (
              <Link className="header__crumb" to={c.to}>{c.label}</Link>
            )}
          </span>
        ))}
      </nav>

      <div className="header__actions">
        <button
          type="button"
          className="header__icon-btn"
          onClick={onToggleTheme}
          aria-label={`Switch to ${theme === 'dark' ? 'light' : 'dark'} mode`}
        >
          {theme === 'dark' ? <SunIcon /> : <MoonIcon />}
        </button>

        <span className="header__divider" />

        <UserMenu />
      </div>
    </header>
  );
}
